// extracted by mini-css-extract-plugin
module.exports = {"buttonPrimary":"ButtonPrimary-module--button-primary--1Y0U0"};